var _circle, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutcome4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F43E3E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1049_108215",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1049_108215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 30V11.5C11 10.6716 11.6716 10 12.5 10H14H15.5H17H18.5H20H21.5H23H24.5H26H27.5C28.3284 10 29 10.6716 29 11.5V30L27.5 28.5L26 30L24.5 28.5L23 30L21.5 28.5L20 30L18.5 28.5L17 30L15.5 28.5L14 30L12.5 28.5L11 30ZM14 25H26V23H14V25ZM14 21H26V19H14V21ZM14 17H26V15H14V17Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutcome4);
export default __webpack_public_path__ + "static/media/outcome4.313df2463c27f391f77e8722a0d9fb69.svg";
export { ForwardRef as ReactComponent };